import { createFileRoute } from '@tanstack/react-router';
import EventDetailPage from '@/pages/EventDetailPage.jsx';
import { SignalsError, SignalsPending } from '@/components/signals/SignalBits.jsx';
import { getSignalEvent } from '@/api';

function EventDetailRoute() {
  const ev = Route.useLoaderData();
  return <EventDetailPage ev={ev} />;
}

export const Route = createFileRoute('/events/$id')({
  loader: ({ params }) => getSignalEvent(params.id),
  component: EventDetailRoute,
  pendingComponent: SignalsPending,
  pendingMs: 200,
  errorComponent: ({ error }) => <SignalsError title="Couldn’t load this event" error={error} />,
});
